import React, { useState, useEffect } from 'react'
import CustomBox from "../CustomComponents/CustomBox/CustomBox"
import CustomTypography from '../CustomComponents/CustomTypography/CustomTypography';
import SchoolIcon from "../../assets/images/walkingToSchool.svg";
import DrivingBanIcon from "../../assets/images/drivingBanRed.svg";
import SeverityIcon from "../../assets/images/severity.svg";
import MotorwayIcon from "../../assets/images/motorwayRed.svg";
import Phone from "../../assets/images/phone.svg";
import Call from "../../assets/images/call.svg";
import Bitmap from "../../assets/images/bitmap.png";
import CompaIcon from "../../assets/images/compa.png";
import TeletracIcon from "../../assets/images/teletrac.png";
import QuartixIcon from "../../assets/images/quatrix.png";
import MasternautIcom from "../../assets/images/masternaut.png";
import RacIcon from "../../assets/images/RAC.png";
import CustomIconButton from "../CustomComponents/CustomIconButton/CustomIconButton";
import ArrowBack from "@material-ui/icons/ArrowBack";
import clsx from "clsx";
import DateTime from "../DateTime/DateTime";
import { useStyles } from "../../assets/jss/DriverTripEventCard";
import { Box, Card, Divider, Grid, IconButton, Link, Typography } from '@material-ui/core';
import { useTranslation } from "react-i18next";
import { CALL_EVENT, CALL_EVENT_DESC_ENUM, EventTypes, PHONE_USAGE_EVENT, PHONE_USAGE_EVENT_DESC_ENUM, ProviderCodes, TripGernyEnum } from '../../config/app-globals.enum'
import { getEventType } from "../../services/LocalStorageService";
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import GoogleMapIcon from "../../assets/images/googleMapIcon.png";
import { getEventWithAddressAPI } from '../../services/DriverTripList';
import CustomCircularProgress from '../CustomComponents/CustomCircularProgress/CustomCircularProgress';
import { NavLink } from "react-router-dom";

function DriverTripEventCard(props) {
    const { t } = useTranslation();
    const { selectedEvent, setSelectedEvent } = props;
    const classes = useStyles();
    const [selectedEventType, setSelectedEventType] = useState(null);
    const [selectedEventTypeText, setSelectedEventTypeText] = useState('');
    const [localEventType] = React.useState(getEventType);
    const [expandEventCard, setExpandEventCard] = useState(true);
    const [locationAddressLoading, setLocationAddressLoading] = useState(false);
    const [viewLess, setViewLess] = useState(false);

    const speedingChildEvents = [13, 14, 15, 16, 17, 18];
    const brakingChildEvents = [6, 7, 8];
    const corneringChildEvents = [9, 10, 11];
    const distractionsChildEvents = [21, 22];
    const accelerationChildEvents = [19, 23];

    useEffect(() => {
        if (selectedEvent) {
            if (speedingChildEvents.includes(+selectedEvent.eventTypeId)) {
                setSelectedEventType(EventTypes.SPEEDING);
                setSelectedEventTypeText(t(`SPEEDING`));
                if ([null, undefined].includes(selectedEvent.startAddress) || [null, undefined].includes(selectedEvent.endAddress)) {
                    getEventWithAddress(EventTypes.SPEEDING);
                }
            } else if (brakingChildEvents.includes(+selectedEvent.eventTypeId)) {
                setSelectedEventType(EventTypes.BRAKING);
                setSelectedEventTypeText(t(`BRAKING`));
            } else if (corneringChildEvents.includes(+selectedEvent.eventTypeId)) {
                setSelectedEventType(EventTypes.CORNERING);
                setSelectedEventTypeText(t(`CORNERING`));
            } else if (accelerationChildEvents.includes(+selectedEvent.eventTypeId)) {
                setSelectedEventType(EventTypes.ACCELERATION);
                setSelectedEventTypeText(t(`ACCELERATION`));
            } else if (distractionsChildEvents.includes(+selectedEvent.eventTypeId)) {
                setSelectedEventType(EventTypes.DISTRACTION);
                setSelectedEventTypeText(t(`DISTRACTION`));
                if ([null, undefined].includes(selectedEvent.startAddress) || [null, undefined].includes(selectedEvent.endAddress)) {
                    getEventWithAddress(EventTypes.DISTRACTION);
                }
            } else if (selectedEvent.tripPoint === TripGernyEnum.TRIP_START) {
                setSelectedEventTypeText(t(`TRIP_START_POINT`));
            } else if (selectedEvent.tripPoint === TripGernyEnum.TRIP_END) {
                setSelectedEventTypeText(t(`TRIP_END_POINT`));
            }
        }
        document.getElementById("tripItem").style['display'] = 'block';
    }, [selectedEvent]);

    /* useEffect(() => {
        if (localEventType && localEventType.length > 0) {
            const distractionEventObj = localEventType.find(
                (event) => event.code === selectedEventTypeText
            );
            setSelectedEventObj(distractionEventObj);
        }
    }, [localEventType]); */

    /* function secondsToHms(d) {
        d = Number(d);
        var h = Math.floor(d / 3600);
        var m = Math.floor(d % 3600 / 60);
        var s = Math.floor(d % 3600 % 60);

        var hDisplay = h > 0 ? h + (h == 1 ? " Hour " : " Hour's ") : "";
        var mDisplay = m > 0 ? m + (m == 1 ? " Min. " : " Min's ") : "";
        var sDisplay = s > 0 ? s + (s == 1 ? " Sec" : " Sec's") : "";
        return hDisplay + mDisplay + sDisplay;
    } */

    async function getEventWithAddress(eventType) {
        setLocationAddressLoading(true);
        const data = await getEventWithAddressAPI(props.selectedTrip.tripId, { eventId: selectedEvent.eventId, eventType: eventType });
        if (data && data.status.code === 0 && data.content) {
            if (selectedEvent && selectedEvent.eventId === data.content._id) {
                if (eventType === EventTypes.DISTRACTION) {
                    selectedEvent.startAddress = data.content.startLocation?.address;
                    selectedEvent.endAddress = data.content.endLocation?.address;
                } else {
                    selectedEvent.startAddress = data.content.startAddress;
                    selectedEvent.endAddress = data.content.endAddress;
                }
                setSelectedEvent(selectedEvent);
            }
        }
        setLocationAddressLoading(false);
    }

    function secondsToHms(d: number) {
        let duration = '';
        if (d && d > 0 && Number((d / (60 * 60)).toFixed(2)) >= 1) {
            duration = (d / (60 * 60)).toFixed(2) + " " + t('HOURS');
        } else if (d && d > 0 && Number((d / (60)).toFixed(2)) > 1 && Number((d / (60)).toFixed(2)) < 60) {
            duration = (d / 60).toFixed(2) + " " + t('MINUTES');
        } else if (d && d > 0) {
            duration = d + " " + t('SECONDS');
        } else {
            duration = "-"
        }
        return duration;
    }

    function driverCardClick() {
        setExpandEventCard(!expandEventCard);
        if (expandEventCard) {
            document.getElementById("tripItem").style['display'] = 'none';
        } else {
            document.getElementById("tripItem").style['display'] = 'block';
        }
    }

    function handleViewLess() {
        setViewLess(!viewLess);
    }

    function getProviderIcon(providerCode: string) {
        if (providerCode.toLocaleLowerCase() === ProviderCodes.WEBFLEET.toLocaleLowerCase())
            return Bitmap;
        else if (providerCode.toLocaleLowerCase() === ProviderCodes.COMPA.toLocaleLowerCase())
            return CompaIcon;
        else if (providerCode.toLocaleLowerCase() === ProviderCodes.TELETRAC.toLocaleLowerCase())
            return TeletracIcon;
        else if (providerCode.toLocaleLowerCase() === ProviderCodes.MASTERNAUT.toLocaleLowerCase())
            return MasternautIcom;
        else if (providerCode.toLocaleLowerCase() === ProviderCodes.QUARTIX.toLocaleLowerCase())
            return QuartixIcon;
        else if (providerCode.toLocaleLowerCase() === ProviderCodes.RAC.toLocaleLowerCase())
            return RacIcon;
        else if (providerCode.toLocaleLowerCase() === ProviderCodes.TTN.toLocaleLowerCase())
            return TeletracIcon;
    }

    function getSubEventName(selectedEvent: any) {
        let subEventType = null;
        if (selectedEvent?.eventTypeId && selectedEvent.eventSubTypeId) {
            if (+selectedEvent.eventTypeId === EventTypes.CALL_EVENT) {
                switch (+selectedEvent.eventSubTypeId) {
                    case CALL_EVENT.REJECT_CALL:
                        subEventType = CALL_EVENT_DESC_ENUM.REJECT_CALL;
                        break;
                    case CALL_EVENT.ANSWER_CALL:
                        subEventType = CALL_EVENT_DESC_ENUM.ANSWER_CALL;
                        break;
                    case CALL_EVENT.OUTGOING_CALL:
                        subEventType = CALL_EVENT_DESC_ENUM.OUTGOING_CALL;
                        break;
                    case CALL_EVENT.END_CALL:
                        subEventType = CALL_EVENT_DESC_ENUM.END_CALL;
                        break;
                    case CALL_EVENT.IN_CALL:
                        subEventType = CALL_EVENT_DESC_ENUM.IN_CALL;
                        break;
                    default:
                        subEventType = null;
                }
            } else if (+selectedEvent.eventTypeId === EventTypes.PHONE_USAGE_EVENT) {
                switch (+selectedEvent.eventSubTypeId) {
                    case PHONE_USAGE_EVENT.CHARGER_PLUG_IN:
                        subEventType = PHONE_USAGE_EVENT_DESC_ENUM.CHARGER_PLUG_IN;
                        break;
                    case PHONE_USAGE_EVENT.CHARGER_PLUG_OUT:
                        subEventType = PHONE_USAGE_EVENT_DESC_ENUM.CHARGER_PLUG_OUT;
                        break;
                    case PHONE_USAGE_EVENT.DEVICE_LOCK:
                        subEventType = PHONE_USAGE_EVENT_DESC_ENUM.DEVICE_LOCK;
                        break;
                    case PHONE_USAGE_EVENT.DEVICE_UNLOCK:
                        subEventType = PHONE_USAGE_EVENT_DESC_ENUM.DEVICE_UNLOCK;
                        break;
                    case PHONE_USAGE_EVENT.SCREEN_DISPLAY_OFF:
                        subEventType = PHONE_USAGE_EVENT_DESC_ENUM.SCREEN_DISPLAY_OFF;
                        break;
                    case PHONE_USAGE_EVENT.SCREEN_DISPLAY_ON:
                        subEventType = PHONE_USAGE_EVENT_DESC_ENUM.SCREEN_DISPLAY_ON;
                        break;
                    default:
                        subEventType = null;
                }
            }
        }
        return subEventType;
    }

    return (
        <Card elevation={2} className={classes.cardWrapper}>

            <Box className={clsx(classes.tripItemRow, classes.tripItemRowCenter, classes.backButtonTextContainerBox)}>
                <CustomIconButton className={classes.backIcon} onTouchEndCapture={() => setSelectedEvent(null)} onClick={() => setSelectedEvent(null)}>
                    <ArrowBack className={classes.leftDrawerContainerButtonIcon} />
                </CustomIconButton>
                <Typography component="div" className={classes.backIconText}>
                    {selectedEventTypeText}
                </Typography>
            </Box>
            <Box className={classes.tripItem}>
                <IconButton onTouchEndCapture={() => { driverCardClick() }} onClick={() => { driverCardClick() }} className={classes.eventCardExpandButton}>
                    {expandEventCard ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
                </IconButton>
            </Box>
            <Box id="tripItem" className={classes.tripItem}>
                {selectedEventType === EventTypes.DISTRACTION &&
                    <>
                        {selectedEvent.tripPoint !== TripGernyEnum.TRIP_START && selectedEvent.tripPoint !== TripGernyEnum.TRIP_END &&
                            <>
                                {locationAddressLoading ? <CustomCircularProgress /> :
                                    <>
                                        <Box className={classes.tripItemRow}>
                                            <Box className={classes.tripItemIconBox}>
                                                <Box className={classes.tripItemIconStart}>
                                                </Box>
                                                <Box className={classes.dottedLine}></Box>
                                            </Box>
                                            <Box className={classes.tripItemSideBox}>
                                                <Box className={(selectedEvent.startAddress !== null && selectedEvent.startAddress !== undefined) ? classes.eventAddress : classes.eventNoAddress}>
                                                    {(selectedEvent.startAddress !== null && selectedEvent.startAddress !== undefined) ?
                                                        props.getAddressFromString(selectedEvent.startAddress) :
                                                        t("LOCATION_DATA_NOT_FOUND")
                                                    }
                                                </Box>
                                                <Box className={classes.eventDate}>
                                                    <DateTime inputDate={selectedEvent.startTime} returnFormat="DD MMM YYYY" /> |{" "}<DateTime inputDate={selectedEvent.startTime} returnFormat="hh:mm A" />
                                                </Box>
                                            </Box>
                                        </Box>
                                        <Box className={classes.tripItemRow}>
                                            <Box className={classes.tripItemIconBox}>
                                                <Box className={classes.tripItemIconEnd}>
                                                </Box>
                                            </Box>
                                            <Box className={classes.tripItemSideBox}>
                                                <Box className={(selectedEvent.endAddress !== null && selectedEvent.endAddress !== undefined) ? classes.eventAddress : classes.eventNoAddress}>
                                                    {(selectedEvent.endAddress !== null && selectedEvent.endAddress !== undefined) ?
                                                        props.getAddressFromString(selectedEvent.endAddress) :
                                                        t("LOCATION_DATA_NOT_FOUND")
                                                    }
                                                </Box>
                                                <Box className={classes.eventDate}>
                                                    <DateTime inputDate={selectedEvent.endTime} returnFormat="DD MMM YYYY" /> |{" "}<DateTime inputDate={selectedEvent.endTime} returnFormat="hh:mm A" />
                                                </Box>
                                            </Box>
                                        </Box>
                                    </>
                                }
                                <Divider light className={classes.dividerClass} />
                                <Box className={classes.iconContainer}>
                                    <Box display="flex" alignItems="center" justifyContent="space-between" className={classes.eventBox}>
                                        {selectedEvent.tripPoint !== TripGernyEnum.TRIP_START && selectedEvent.tripPoint !== TripGernyEnum.TRIP_END && selectedEvent.eventTypeId === localEventType[props.selectedEvent.eventTypeId - 1].id &&
                                            localEventType[props.selectedEvent.eventTypeId - 1].code === "CALL_EVENT" ?
                                            <img className={classes.eventsIcon} src={Call} /> :
                                            null}
                                        {selectedEvent.tripPoint !== TripGernyEnum.TRIP_START && selectedEvent.tripPoint !== TripGernyEnum.TRIP_END && selectedEvent.eventTypeId === localEventType[props.selectedEvent.eventTypeId - 1].id &&
                                            localEventType[props.selectedEvent.eventTypeId - 1].code === "PHONE_USAGE_EVENT" ?
                                            <img className={classes.eventsIcon} src={Phone} /> :
                                            null}
                                        {selectedEvent.severity > 2 ? <img className={classes.eventsIcon} src={SeverityIcon} /> : null}
                                        <CustomTypography className={classes.otherKey}>
                                            {t(secondsToHms((new Date(selectedEvent.endTime).getTime() - new Date(selectedEvent.startTime).getTime()) / 1000))}
                                        </CustomTypography>
                                    </Box>
                                </Box>
                                <Divider light className={classes.dividerClass} />
                            </>
                        }
                        <Box className={classes.tripDetailsContainer}>
                            {props.selectedEvent.tripPoint !== undefined && props.selectedEvent.tripPoint !== null && props.selectedEvent.tripPoint !== TripGernyEnum.TRIP_END ? null : (
                                <>
                                    {selectedEvent.averageSpeed !== undefined && selectedEvent.averageSpeed !== null &&
                                        <CustomBox className={classes.otherKeyValuesWrapper}>
                                            <CustomTypography className={classes.otherKey}>
                                                {t("AVG_SPEED")}
                                            </CustomTypography>
                                            {selectedEvent?.averageSpeed ? <CustomTypography className={classes.otherValue}>
                                                {selectedEvent.averageSpeed}
                                            </CustomTypography> : null}
                                        </CustomBox>
                                    }
                                    {selectedEvent.coastingIndicator !== undefined && selectedEvent.coastingIndicator !== null &&
                                        <CustomBox className={classes.otherKeyValuesWrapper}>
                                            <CustomTypography className={classes.otherKey}>
                                                {t("COASTING_INDICATOR")}
                                            </CustomTypography>
                                            {selectedEvent?.coastingIndicator ? <CustomTypography className={classes.otherValue}>
                                                {selectedEvent.coastingIndicator}
                                            </CustomTypography> : null}
                                        </CustomBox>
                                    }
                                    {selectedEvent.distance !== undefined && selectedEvent.distance !== null &&
                                        <CustomBox className={classes.otherKeyValuesWrapper}>
                                            <CustomTypography className={classes.otherKey}>
                                                {t("DISTANCE")}
                                            </CustomTypography>
                                            {selectedEvent?.distance ? <CustomTypography className={classes.otherValue}>
                                                {selectedEvent.distance}
                                            </CustomTypography> : null}
                                        </CustomBox>
                                    }
                                    {selectedEvent.providerUid !== undefined && selectedEvent.providerUid !== null &&
                                        <CustomBox className={classes.otherKeyValuesWrapper}>
                                            <CustomTypography className={classes.otherKey}>
                                                {t("DRIVER_UID")}
                                            </CustomTypography>
                                            {selectedEvent?.providerUid ? <CustomTypography className={classes.otherValue}>
                                                {selectedEvent.providerUid}
                                            </CustomTypography> : null}
                                        </CustomBox>
                                    }
                                    {selectedEvent.userId !== undefined && selectedEvent.userId !== null &&
                                        <CustomBox className={classes.otherKeyValuesWrapper}>
                                            <CustomTypography className={classes.otherKey}>
                                                {t("DRIVER ID")}
                                            </CustomTypography>
                                            {selectedEvent?.userId ? <CustomTypography className={classes.otherValue}>
                                                {selectedEvent.userId}
                                            </CustomTypography> : null}
                                        </CustomBox>
                                    }
                                    {/* {selectedEvent.duration !== undefined && selectedEvent.duration !== null && selectedEvent.duration !== 0 &&
                                        <CustomBox className={classes.otherKeyValuesWrapper}>
                                            <CustomTypography className={classes.otherKey}>
                                                {t("DURATION")}
                                            </CustomTypography>
                                            {selectedEvent?.duration ? <CustomTypography className={classes.otherValue}>
                                                {secondsToHms(selectedEvent.duration)}
                                            </CustomTypography> : null}
                                        </CustomBox>
                                    } */}
                                    {selectedEvent.endFormattedLatitude !== undefined && selectedEvent.endFormattedLatitude !== null &&
                                        <CustomBox className={classes.otherKeyValuesWrapper}>
                                            <CustomTypography className={classes.otherKey}>
                                                {t("END_FORMATTED_LATTITUDE")}
                                            </CustomTypography>
                                            {selectedEvent?.endFormattedLatitude ? <CustomTypography className={classes.otherValue}>
                                                {selectedEvent.endFormattedLatitude}
                                            </CustomTypography> : null}
                                        </CustomBox>
                                    }
                                </>
                            )}
                        </Box>
                    </>
                }
                {(selectedEvent.tripPoint !== TripGernyEnum.TRIP_START && selectedEvent.tripPoint !== TripGernyEnum.TRIP_END && selectedEventType !== EventTypes.SPEEDING) ?
                    <>
                        <Box className={classes.dateItem}>
                            <Box className={classes.tripItemSideBox}>
                                <CustomTypography className={classes.callBtText}>
                                    {t(localEventType[props.selectedEvent.eventTypeId - 1].name)}
                                </CustomTypography>
                                <CustomTypography className={classes.subEventDescription}>
                                    {`- ${t(getSubEventName(selectedEvent))}`}
                                </CustomTypography>
                            </Box>
                        </Box>
                        <Divider light className={classes.dividerClass} />
                    </> : null
                }
                {selectedEventType === EventTypes.SPEEDING &&
                    <>
                        {locationAddressLoading ?
                            <CustomCircularProgress /> :
                            <>
                                <Box className={classes.tripItemRow}>
                                    <Box className={classes.tripItemIconBox}>
                                        <Box className={classes.tripItemIconStart}>
                                        </Box>
                                        <Box className={classes.dottedLine}></Box>
                                    </Box>
                                    <Box className={classes.tripItemSideBox}>
                                        <Box className={(selectedEvent.startAddress !== null && selectedEvent.startAddress !== undefined) ? classes.eventAddress : classes.eventNoAddress}>
                                            {(selectedEvent.startAddress !== null && selectedEvent.startAddress !== undefined) ?
                                                props.getAddressFromString(selectedEvent.startAddress) :
                                                t("LOCATION_DATA_NOT_FOUND")
                                            }
                                        </Box>
                                        <Box className={classes.eventDate}>
                                            <DateTime inputDate={selectedEvent.startTime} returnFormat="DD MMM YYYY" /> |{" "}<DateTime inputDate={selectedEvent.startTime} returnFormat="hh:mm A" />
                                        </Box>
                                    </Box>
                                </Box>
                                <Box className={classes.tripItemRow}>
                                    <Box className={classes.tripItemIconBox}>
                                        <Box className={clsx(classes.tripItemIconEnd)}>
                                        </Box>
                                    </Box>
                                    <Box className={classes.tripItemSideBox}>
                                        <Box className={(selectedEvent.endAddress !== null && selectedEvent.endAddress !== undefined) ? classes.eventAddress : classes.eventNoAddress}>
                                            {(selectedEvent.endAddress !== null && selectedEvent.endAddress !== undefined) ?
                                                props.getAddressFromString(selectedEvent.endAddress) :
                                                t("LOCATION_DATA_NOT_FOUND")
                                            }
                                        </Box>
                                        <Box className={classes.eventDate}>
                                            <DateTime inputDate={selectedEvent.endTime} returnFormat="DD MMM YYYY" /> |{" "}<DateTime inputDate={selectedEvent.endTime} returnFormat="hh:mm A" />
                                        </Box>
                                    </Box>
                                </Box>
                            </>}
                        {selectedEvent.tripPoint !== TripGernyEnum.TRIP_START && selectedEvent.tripPoint !== TripGernyEnum.TRIP_END &&
                            <>
                                <Divider light className={classes.dividerClass} />
                                <Box className={classes.tripItemRow}>
                                    <Grid container justifyContent="space-between" className={classes.stateBoxContainer}>
                                        <Box className={classes.stateBoxContainerItem}>
                                            <Typography component="div" className={classes.stateTitle}>
                                                {t("MAX_SPEED")}
                                            </Typography>
                                            <Typography component="div" className={classes.stateValue}>
                                                {Math.round((selectedEvent.maxSpeed))} {t("MPH")}
                                            </Typography>
                                        </Box>
                                        <Box className={classes.stateBoxContainerItem}>
                                            <Typography component="div" className={classes.stateTitle}>
                                                {t("SPEED_LIMIT")}
                                            </Typography>
                                            <Typography component="div" className={classes.stateValue}>
                                                {Math.floor((selectedEvent.roadSpeedLimit))} {t("MPH")}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                </Box>
                                <Divider light className={classes.dividerClass} />
                                <Box className={classes.tripItemRow}>
                                    <Grid container justifyContent="flex-start" className={classes.stateBoxContainer}>
                                        {selectedEvent.isDrivingBan === true ?
                                            <Grid item xs={6}>
                                                <Box display="flex" alignItems="center" className={classes.eventBox}>
                                                    <img className={classes.eventsIcon} src={DrivingBanIcon} />
                                                </Box>
                                            </Grid>
                                            : null}
                                        {selectedEvent.isSchoolRunSpeeding === true ?
                                            <Grid item xs={6}>
                                                <Box display="flex" alignItems="center" className={classes.eventBox}>
                                                    <img className={classes.eventsIcon} src={SchoolIcon} />
                                                </Box>
                                            </Grid>
                                            : null}
                                        {selectedEvent.isSevere === true ?
                                            <Grid item xs={6}>
                                                <Box display="flex" alignItems="center" className={classes.eventBox}>
                                                    <img className={classes.eventsIcon} src={SeverityIcon} />
                                                </Box>
                                            </Grid>
                                            : null}
                                        {selectedEvent.isMotorWaySpeeding === true ?
                                            <Grid item xs={6}>
                                                <Box display="flex" alignItems="center" className={classes.eventBox}>
                                                    <img className={classes.eventsIcon} src={MotorwayIcon} />
                                                </Box>
                                            </Grid>
                                            : null}
                                    </Grid>
                                </Box>
                                <Divider light className={classes.dividerClass} />
                            </>
                        }
                        {selectedEvent.tripPoint !== TripGernyEnum.TRIP_START && selectedEvent.tripPoint !== TripGernyEnum.TRIP_END &&
                            <CustomBox className={classes.otherKeyValuesWrapper}>
                                <CustomTypography className={classes.otherKey}>
                                    {t("AVG_SPEED")}
                                </CustomTypography>
                                {selectedEvent?.averageSpeed ? <CustomTypography className={classes.otherValue}>
                                    {Math.floor(selectedEvent.averageSpeed)} {t("MPH")}
                                </CustomTypography> : null}
                            </CustomBox>
                        }
                    </>
                }
                {props.selectedEvent.tripPoint !== undefined && props.selectedEvent.tripPoint !== null && props.selectedEvent.tripPoint !== TripGernyEnum.TRIP_END ? null : !viewLess ? (
                    <>
                        {selectedEvent.tripPoint === TripGernyEnum.TRIP_END &&
                            <Box className={classes.tripItemRow}>
                                <Box className={classes.tripItemIconBox}>
                                    <Box className={classes.tripItemIconEnd}>
                                    </Box>
                                </Box>
                                <Box className={classes.tripItemSideBox}>
                                    <Box className={classes.eventAddress}>
                                        {(selectedEvent.endAddress !== null && selectedEvent.endAddress !== undefined) ?
                                            props.getAddressFromString(selectedEvent.endAddress) :
                                            <CustomTypography className={classes.otherKey}>
                                                {t("LOCATION_DATA_NOT_FOUND")}
                                            </CustomTypography>
                                        }
                                    </Box>
                                    <Box className={classes.eventDate}>
                                        <DateTime inputDate={selectedEvent.endTime} returnFormat="DD MMM YYYY" /> |{" "}<DateTime inputDate={selectedEvent.endTime} returnFormat="hh:mm A" />
                                    </Box>
                                </Box>
                            </Box>
                        }
                        <CustomBox className={classes.otherKeyValuesWrapper}>
                            <CustomTypography className={classes.otherKey}>
                                {t("END_LOCATION")}
                            </CustomTypography>
                            {selectedEvent?.endLatitude && selectedEvent.endLongitude ?
                                <CustomTypography className={classes.otherValue}>
                                    {`${(selectedEvent.endLatitude).toFixed(6)} | ${(selectedEvent.endLongitude).toFixed(6)}`}
                                    <a href={`http://maps.google.com/?q=${selectedEvent.endLatitude},${selectedEvent.endLongitude}`} target="_blank" rel="noopener noreferrer">
                                        <img src={GoogleMapIcon} className={classes.mapIcon} alt={t("END_LOCATION")} />
                                    </a>
                                </CustomTypography> : null}
                        </CustomBox>
                    </>
                ) : null}

                {props.selectedEvent.tripPoint !== undefined && props.selectedEvent.tripPoint !== null && props.selectedEvent.tripPoint !== TripGernyEnum.TRIP_START ? null : !viewLess ? (
                    <>
                        {selectedEvent.tripPoint === TripGernyEnum.TRIP_START &&
                            <Box className={classes.tripItemRow}>
                                <Box className={classes.tripItemIconBox}>
                                    <Box className={classes.tripItemIconStart}>
                                    </Box>
                                </Box>
                                <Box className={classes.tripItemSideBox}>
                                    <Box className={classes.eventAddress}>
                                        {(selectedEvent.startAddress !== null && selectedEvent.startAddress !== undefined) ?
                                            props.getAddressFromString(selectedEvent.startAddress) :
                                            <CustomTypography className={classes.otherKey}>
                                                {t("LOCATION_DATA_NOT_FOUND")}
                                            </CustomTypography>
                                        }
                                    </Box>
                                    <Box className={classes.eventDate}>
                                        <DateTime inputDate={selectedEvent.startTime} returnFormat="DD MMM YYYY" /> |{" "}<DateTime inputDate={selectedEvent.startTime} returnFormat="hh:mm A" />
                                    </Box>
                                </Box>
                            </Box>
                        }
                        <CustomBox className={classes.otherKeyValuesWrapper}>
                            <CustomTypography className={classes.otherKey}>
                                {t("START_LOCATION")}
                            </CustomTypography>
                            {selectedEvent?.startLatitude && selectedEvent.startLongitude ?
                                <CustomTypography className={classes.otherValue}>
                                    {`${(selectedEvent.startLatitude).toFixed(6)} | ${(selectedEvent.startLongitude).toFixed(6)}`}
                                    <a href={`http://maps.google.com/?q=${selectedEvent.startLatitude},${selectedEvent.startLongitude}`} target="_blank" rel="noopener noreferrer" >
                                        <img src={GoogleMapIcon} className={classes.mapIcon} alt={t("START_LOCATION")} />
                                    </a>
                                </CustomTypography> : null}
                        </CustomBox>
                    </>
                ) : null}
                <Box>
                    <CustomBox className={classes.viewLessOrMoreWrapper}>
                        <CustomTypography className={classes.otherKey}>
                            {t("DATA_SORUCE")}
                        </CustomTypography>
                        <img className={classes.webfleetIcon} src={getProviderIcon(props.selectedTrip.providerCode)} />
                    </CustomBox>
                </Box>
                <CustomBox className={classes.eventDetailsBox}>
                    {props.selectedEvent && props.selectedEvent.eventId && <>
                        <NavLink
                            className={classes.eventDetailsLink}
                            to={`/eventdetails/${props.selectedTrip.userId}/${props.selectedEvent.eventId}/${props.selectedEvent.reportStatus}`}>
                            {t("EVENT_DETAILS")} &rarr;
                        </NavLink>
                    </>}
                </CustomBox>
                <Box className={classes.viewLessOrMoreItem}>
                    <CustomBox className={classes.viewLessOrMoreWrapper}>
                        <Link underline="none" onTouchEndCapture={handleViewLess} onClick={handleViewLess}>
                            {viewLess ?
                                <CustomTypography className={classes.viewLessOrMore}>
                                    {t("VIEW_MORE")}
                                </CustomTypography> :
                                <CustomTypography className={classes.viewLessOrMore}>
                                    {t("VIEW_LESS")}
                                </CustomTypography>
                            }
                        </Link>
                    </CustomBox>
                </Box>
            </Box>
        </Card>
    )
}

export default DriverTripEventCard;